import { createContext } from 'react';
import {
  AppConfigService,
  AppVersioningService,
  BaseUrlHttpAdapter,
  EnvironmentService,
  ErrorMessageService,
  FeatureFlagService,
  GlobalModalsService,
  HttpService,
  IntentManagementService,
  LoadingService,
  LokiService,
  ProcessEngineService,
  TextToPromptService,
  UserService,
  WorkflowService
} from '../services';

export function createServiceContext(): ServiceContextType {
  const errorMessageService = new ErrorMessageService();
  const featureFlagService = new FeatureFlagService();
  const environmentService = new EnvironmentService(
    errorMessageService,
    new HttpService([
      new BaseUrlHttpAdapter(EnvironmentService.baseUrl)
    ])
  );
  const globalModalsService = new GlobalModalsService();
  const userService = new UserService(
    environmentService,
    errorMessageService,
    globalModalsService,
    new HttpService([new BaseUrlHttpAdapter('/user')]),
    new HttpService([new BaseUrlHttpAdapter('/roles')])
  );
  const intentService = new IntentManagementService(
    new HttpService([
      new BaseUrlHttpAdapter(IntentManagementService.baseUrl),
      userService
    ])
  );
  const workflowService = new WorkflowService(
    new HttpService([
      new BaseUrlHttpAdapter(WorkflowService.baseUrl),
      userService
    ])
  );

  return {
    appConfigService: new AppConfigService(
      errorMessageService,
      new HttpService([
        new BaseUrlHttpAdapter(AppConfigService.baseUrl),
        userService
      ])
    ),
    avsService: new AppVersioningService(
      errorMessageService,
      new HttpService([
        new BaseUrlHttpAdapter(AppVersioningService.baseUrl),
        userService
      ]),
      intentService
    ),
    environmentService,
    errorMessageService,
    featureFlagService,
    globalModalsService,
    intentService,
    loadingService: new LoadingService(),
    lokiService: LokiService.create(globalModalsService),
    processEngineService: new ProcessEngineService(
      new HttpService([
        new BaseUrlHttpAdapter(ProcessEngineService.baseUrl),
        userService
      ])
    ),
    textToPromptService: new TextToPromptService(
      errorMessageService,
      new HttpService([
        new BaseUrlHttpAdapter(TextToPromptService.baseUrl)
      ]),
      workflowService
    ),
    userService,
    workflowService
  };
}

export const defaultServiceContext = createServiceContext();

export const ServiceContext = createContext(defaultServiceContext);

export interface ServiceContextType {
  appConfigService: AppConfigService;
  avsService: AppVersioningService;
  environmentService: EnvironmentService;
  errorMessageService: ErrorMessageService;
  featureFlagService: FeatureFlagService;
  globalModalsService: GlobalModalsService;
  intentService: IntentManagementService;
  loadingService: LoadingService;
  lokiService: LokiService;
  processEngineService: ProcessEngineService;
  textToPromptService: TextToPromptService;
  userService: UserService;
  workflowService: WorkflowService;
}
